import React, { useState, useEffect } from "react";
import "../css/main.scss";

function Main() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = ["/editorial/editorial-01.png", "/editorial/editorial-02.png", "/editorial/editorial-03.png"];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const gridItems = [
    {
      img: "/editorial/editorial-04.png",
      title: "News",
      desc: "Discover practical bowl and chopstick guides for a better everyday table.",
    },
    {
      img: "/editorial/editorial-05.png",
      title: "Rice Bowls",
      desc: "Everyday rice bowls in porcelain, stoneware, glass and stainless steel.",
    },
    {
      img: "/editorial/editorial-06.png",
      title: "Chopsticks",
      desc: "Reusable bamboo, wood, alloy and steel chopsticks for daily meals.",
    },
    {
      img: "/editorial/editorial-07.png",
      title: "Noodle Bowls",
      desc: "Deep bowls for noodles, soup and generous one-bowl meals.",
    },
    {
      img: "/editorial/editorial-08.png",
      title: "Dining Sets",
      desc: "Coordinated bowl-and-chopstick sets for two, four or six diners.",
    },
    {
      img: "/editorial/editorial-09.png",
      title: "Dipping Bowls",
      desc: "Compact dishes and divided bowls for sauces, snacks and side dishes.",
    },
    {
      img: "/editorial/editorial-10.png",
      title: "About",
      desc: "Learn about autumncircle and our focused approach to bowls and chopsticks.",
    },
    {
      img: "/editorial/editorial-11.png",
      title: "Contact",
      desc: "Ask our Hong Kong team about bowl sizes, chopstick materials or an order.",
    },
  ];

  return (
    <div className="main">
      <section className="carousel-section">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide})` }}
          />
        ))}
      </section>

      <section className="grid-section">
        <div className="grid-container">
          {gridItems.map((item, index) => (
            <div className="grid-item" key={index}>
              <div className="img-wrapper">
                <img src={item.img} alt={item.title} />
              </div>
              <div className="content-wrapper">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Main;
